import { Drawer } from '@material-ui/core';
import * as React from 'react';
import { StatusCode } from '../../../../utils/api';
import { DeliveryShipmentAction } from '../../../models/shipments/shipment-action';
import { TransportationSvc } from '../../../service';
import { OrderSearchFilters } from '../../../models/filters/order-search-filters';
import { ShipmentMethod } from '../../../models/enums/shipment-method';
import { OrderSummary } from '../../../models/shared/order-summary';
import { PagedApiResult } from '../../../../models/utilities/paged-request';
import { PagedList } from '../../../../components/paged-list/PagedList';
import { useDispatch } from 'react-redux';
import ShipmentActionAddOrderRow from '../ShipmentActionAddOrderRow';
import { FlyoutSaveCancel } from '../../../../components/flyout-components/FlyoutSaveCancel';
import { ShipmentType } from '../../../models/enums/shipment-type';
import { RunningTotal } from '../../../models/shared/running-total';
import { TransportationUtils } from '../../../helpers';
import { ShipmentTruckTotalsBar } from '../ShipmentTruckTotalsBar';

interface IProps {
    entityType: ShipmentType;
    visible: boolean;
    onClose: any;
    onSuccess: any;
    truckId: number;
    truckVersion: string;
    stop: DeliveryShipmentAction | undefined;
    truckTotals: RunningTotal | undefined;
}

let IGNORE_UNMOUNT_SELECTABLE = false;

export const ActionAddAddon = (props: IProps) => {

    const dispatch = useDispatch();
    const [service] = React.useState(new TransportationSvc());
    const [filterParams] = React.useState(new OrderSearchFilters(ShipmentMethod.Delivery));
    const [availableOrders, setAvailableOrders] = React.useState<PagedApiResult<OrderSummary>>(() => {
        const initial = new PagedApiResult<OrderSummary>();
        initial.pagination = filterParams.paginationInfo;
        return initial;
    });

    const [fullTruckTotal, setFullTruckTotal] = React.useState<RunningTotal>(new RunningTotal());

    React.useEffect(() => {
        if (props.visible && props.stop) {

            setFullTruckTotal(TransportationUtils.calculateTruckTotals(props.truckTotals, [], []));
            getAvailableOrders(props.stop.shipToAddressId);
        }
    }, [props.visible]);

    /**
     * Handler for when the user is done drag selecting items
     * @param evt The draggable event with selected items
     */
    const onDragComplete = (evt: any) => {

        // The select library we use calls dragComplete
        // whenever a component is unmounted.  However,
        // that causes issues.  Hacky, but it's what's 
        // required without changing implemenation.
        if (IGNORE_UNMOUNT_SELECTABLE) {
            return;
        }

        let tmpOrders = { ...availableOrders };

        tmpOrders.results.forEach((itm: OrderSummary) => {
            itm.isChecked = false;
        });

        for (let tmpOrder of tmpOrders.results) {
            for (let evtItem of evt) {
                if (tmpOrder.id === evtItem.props.orderItem.id) {
                    tmpOrder.isChecked = true;
                }
            }
        }

        setAvailableOrders(tmpOrders);

        // Truck totals plus the orders picked to add
        const selecteds = tmpOrders.results.filter((itm: OrderSummary) => itm.isChecked);
        setFullTruckTotal(TransportationUtils.calculateTruckTotals(props.truckTotals, [], selecteds));
    };

    /**
     * Fetch the open orders for this address
     * @param id The ship-to address ID to fetch orders for
     */
    async function getAvailableOrders(id: number) {
        const filters = new OrderSearchFilters(ShipmentMethod.Delivery, id, undefined, undefined, undefined, undefined, undefined, '1');
        const response = await service.getOrdersForShipTo(filters);
        if (response.status === StatusCode.Success) {
            setAvailableOrders(response.data);
        }
    }

    /**
     * Close handler for the flyout
     */
    const onClose = () => {
        props.onClose();
    };

    const onSave = async () => {

        var orderIds = availableOrders.results
            .filter(o => o.isChecked)
            .map(o => o.id);

        const result = await service.addAddon(
            orderIds,
            props.truckId,
            props.stop!.id,
            props.truckVersion,
            props.entityType
        );

        if (result.status === StatusCode.Success) {
            props.onSuccess();
        }
    };

    return <Drawer
        anchor="right"
        onClose={onClose}
        open={props.visible}>
        <div className="stop-action-drawer stop-action-add-addon">
            <div className="row">
                <div className="col-md-12">
                    <h1>Add-on</h1>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    <PagedList
                        noResultsMessage="No available orders found for this address."
                        searchCallback={() => { return; }}
                        data={availableOrders}
                        filterProps={filterParams}
                        hideFilterBar={true}
                        onFilterUpdate={() => { return; }}
                        skipScroll={true}
                        selectableClass="transport-order-selectable"
                        hidePager={true}
                        reduxDispatch={dispatch}
                        useClientSelectablePositioning={true}
                        enabledDrag={true}
                        onDragComplete={onDragComplete}
                        rowRenderer={(order: OrderSummary, extraProps: any) =>
                            <ShipmentActionAddOrderRow key={`stop-order-${order.id}`} orderItem={order} {...extraProps} />
                        }
                    />
                </div>
            </div>
            <ShipmentTruckTotalsBar
                entityType={props.entityType}
                totals={fullTruckTotal}
            />
            <FlyoutSaveCancel
                onSave={onSave}
                onCancel={props.onClose}
            />
        </div>
    </Drawer>;
}